import { Component, ErrorInfo, ReactNode } from 'react';
import { withTranslation } from 'react-i18next';
import { reportProblem } from 'src/services/dataApi';
import { sessionRecordingService } from 'src/services/sessionRecordingService';
import ErrorMessage from './ErrorMessage';

interface IProps {
  children: ReactNode;
}

interface IState {
  hasError: boolean;
  errorInfo: any;
}
class ErrorBoundaryComponent extends Component<IProps, IState> {
  public state: IState = {
    hasError: false,
    errorInfo: null,
  };

  public static getDerivedStateFromError(): IState {
    return { hasError: true, errorInfo: null };
  }

  public async componentDidMount(): Promise<void> {
    await sessionRecordingService.loadClarityRecorder();
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo);
    sessionRecordingService.recorders.clarityRecorder?.trackEvent('Crash');

    // TO DO send email
    if (process.env.REACT_APP_CRASH_EMAIL_REPORT_ENABLE === 'true') {
      reportProblem(error);
    }
  }

  public render(): ReactNode {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <ErrorMessage />;
    }

    return children;
  }
}

export default withTranslation()(ErrorBoundaryComponent);
